import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ChargeMethod, FocusInputType, GeneralConfigType, InteractionType, KeyValues5, KeyValueSet, LocalService, NotificationType, Payment, Status, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-add-message-credits',
  templateUrl: './add-message-credits.component.html',
  styleUrls: ['./add-message-credits.component.scss']
})
export class AddMessageCreditsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["sms_settings"]; items: KeyValues5[]; maxBodyHeight = 0;
  businessId = ''; relationShipType: InteractionType = InteractionType.Business; notificationType: NotificationType = NotificationType.WhatsApp;
  notificationTypes: KeyValueSet[]; isShowPayment = false; ctryId = ''; amount = 0; datas: KeyValues5[];
  elementIds: any = {
    add_credits_txt: 'add_credits_txt',
    add_credits_btn: 'add_credits_btn'
  };
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public billingManagementService: BillingManagementService, private activeModal: NgbActiveModal, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.configurationManagementService.ensurePricing();
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.NotificationType).subscribe(result => {
      this.notificationTypes = result;
    });
    this.billingManagementService.getMessageCredits(this.businessId, this.relationShipType).subscribe(result => {
      this.items = result;
      this.items.forEach(x => x.v5 = null);
      if (this.items.length == 0) {
        this.localService.showMessage(this.localService.languageContent.sms_settings.no_active_notifications);
        this.activeModal.close({ event: TriggeredEvent.Close });
      }
      setTimeout(() => {
        let nextNotificationType = this.elementIds.add_credits_txt + '_' + this.notificationType.toString();
        let element = document.getElementById(nextNotificationType);
        if (element) {
          this.localService.onFocusNextInput(nextNotificationType, FocusInputType.TextBox);
        } else if (this.items.length > 0) {
          this.localService.onFocusNextInput(this.elementIds.add_credits_txt + '_' + this.items[0].v2, FocusInputType.TextBox);
        }
      }, 100);
    });
  }

  onEnter(strNotificationType: string) {
    let nextNotificationType = this.elementIds.add_credits_txt + '_' + (parseInt(strNotificationType) + 1).toString();
    let element = document.getElementById(nextNotificationType);
    if (element) {
      this.localService.onFocusNextInput(nextNotificationType, FocusInputType.TextBox);
    } else {
      this.onAdd();
    }
  }

  onAdd() {
    if (this.items.filter(x => x.value != null && x.value > 0).length > 0) {
      this.items.forEach(x => x.v5 = x.value && x.value > 0 ? x.value.toString() : "");
      this.datas = this.items;
      this.isShowPayment = true;
    } else {
      this.activeModal.close({ event: TriggeredEvent.Close });
    }
  }

  onInput(id: string, value: number, strType: string) {
    let iType = parseInt(strType);
    let price = this.localService.pricing.find(x => x.chargeMethod == ChargeMethod.NotificationType && x.chargeForType == iType);
    if (price) {
      this.items.find(x => x.key == id).v5 = value ? (value * price.amount).toString() : null;
      this.amount = this.items.filter(item => item.v5).reduce((sum, current) => sum + parseFloat(current.v5), 0);
    } else {
      this.localService.showInformation(this.localService.languageContent.sms_settings.configure_price, true);
    }
  }

  onPaymentProccesed(e: any) {
    this.activeModal.close({ event: TriggeredEvent.Ok });
  }

  onShowPaymentChange(res: any) {
    if (res) {
      if (res.status == Status.Allowed) {
        this.isShowPayment = false;
        this.activeModal.close({ event: TriggeredEvent.Ok });
        this.onLoad();
      }
    }
  }
}
